import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';

import ManageRatings from '../../../components/SiteAdmin/ManageRatings';
import Loader from '../../../components/Common/Loader/Loader';
import getReviews from './getReviews.graphql'
import messages from '../../../locale/messages';

import { withQuery } from '../../../hoc/withGraphql';

export class Ratings extends Component {

    static defaultProps = {
        booking: {
            loading: true
        }
    }

    render() {
        const { reviews, reviews: { loading, getReviews } } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <Loader type={"page"} show={loading}>
                <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.ratings)}</h1>
                {!loading && <ManageRatings reviews={reviews} />}
            </Loader>
        );
    }
}

export default compose(
    injectIntl,
    withQuery(getReviews, {
        name: 'reviews',
        options: {
            variables: {
                currentPage: 1,
                searchList: ''
            },
            fetchPolicy: 'network-only',
            ssr: false
        }
    })
)(Ratings);